var render = function() {
  var this$1 = this
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-container",
    { staticClass: "DashboardBox", attrs: { fluid: "" } },
    [
      _c(
        "v-row",
        [
          _c("v-col", { attrs: { cols: "12" } }, [
            _c(
              "div",
              { staticClass: "d-flex justify-space-between pa-3 align-center" },
              [
                _c("div", { staticClass: "d-flex align-center" }, [
                  _c(
                    "div",
                    [
                      _c(
                        "v-icon",
                        { staticClass: "mr-4", attrs: { large: "" } },
                        [_vm._v("mdi-account-box")]
                      )
                    ],
                    1
                  ),
                  _c("div", { staticClass: "title-header" }, [
                    _vm._v(
                      " " +
                        _vm._s(
                          _vm.customerManagement
                            ? "Contactos Asociados"
                            : "Directorio de Contactos"
                        ) +
                        " "
                    )
                  ])
                ]),
                (!_vm.isDaycohostUser || _vm.customerManagement) &&
                _vm.$can(
                  this.createAction,
                  this.privilegeAdministrationResourceName
                )
                  ? _c(
                      "v-btn",
                      {
                        staticClass: "hidden-sm-and-down",
                        attrs: { color: "green", dark: "" },
                        on: {
                          click: function() {
                            this$1.SET_FORM_VIEW("creating")
                            this$1.SET_CUSTOMER(
                              this$1.customer ||
                                this$1.currentUser.contact.customer
                            )
                            this$1.$router.push("/portal/create-contact")
                          }
                        }
                      },
                      [_vm._v("Agregar Contactos")]
                    )
                  : _vm._e()
              ],
              1
            )
          ])
        ],
        1
      ),
      false
        ? _c(
            "v-row",
            [
              _c(
                "v-col",
                { attrs: { cols: "12" } },
                [
                  _c(
                    "v-card",
                    { attrs: { "min-height": "650" } },
                    [
                      _c(
                        "v-row",
                        {
                          staticClass: "pa-4",
                          attrs: { align: "center", "no-gutters": "" }
                        },
                        [
                          _c(
                            "div",
                            {
                              staticClass: "title-header",
                              staticStyle: { "font-size": "14px" }
                            },
                            [_vm._v("Detalles de Contacto")]
                          )
                        ]
                      ),
                      _c("v-divider"),
                      _c(
                        "v-container",
                        { staticClass: "align-center" },
                        [
                          _c("br"),
                          _c("br"),
                          _c("br"),
                          _c("br"),
                          _c("br"),
                          _c("br"),
                          _c(
                            "v-row",
                            [
                              _c(
                                "v-col",
                                { staticClass: "d-flex justify-center" },
                                [
                                  _c(
                                    "div",
                                    {
                                      staticClass:
                                        "background-for-icon d-flex align-center justify-center"
                                    },
                                    [
                                      _c(
                                        "v-icon",
                                        {
                                          attrs: {
                                            size: "200",
                                            color: "rgb(150,150,150)"
                                          }
                                        },
                                        [_vm._v("mdi-alert-circle")]
                                      )
                                    ],
                                    1
                                  )
                                ]
                              )
                            ],
                            1
                          ),
                          _c(
                            "v-row",
                            {
                              staticClass: "d-flex justify-center align-center",
                              staticStyle: { "text-align": "center" }
                            },
                            [_c("h2", [_vm._v("Acceso Restringido")])]
                          ),
                          _c(
                            "v-row",
                            { staticClass: "d-flex justify-center" },
                            [
                              _c("v-col", { attrs: { cols: "1" } }),
                              _c(
                                "v-col",
                                {
                                  staticClass:
                                    "d-flex justify-center align-center",
                                  staticStyle: { "text-align": "center" },
                                  attrs: { cols: "10" }
                                },
                                [
                                  _c("h3", [
                                    _vm._v(
                                      "No posee los permisos para visualizar contactos"
                                    )
                                  ])
                                ]
                              ),
                              _c("v-col", { attrs: { cols: "1" } })
                            ],
                            1
                          )
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          )
        : _c(
            "v-row",
            [
              _c(
                "v-col",
                {
                  attrs: {
                    cols: "12",
                    md: "4",
                    lg: "4",
                    xl: "3",
                    "fill-height": ""
                  }
                },
                [
                  _c("directory", {
                    ref: "directory",
                    attrs: {
                      maxHeight: _vm.directoryHeight,
                      size: 35,
                      modalCheck: _vm.modalCheck,
                      contactToDisplay: 14,
                      customer: _vm.customerId,
                      customerManagement: _vm.customerManagement,
                      adminUser: _vm.adminUser
                    },
                    on: { contactClicked: _vm.displayContact }
                  })
                ],
                1
              ),
              _c(
                "v-col",
                { attrs: { cols: "12", md: "8", lg: "8", xl: "9" } },
                [
                  _c(
                    "v-card",
                    { attrs: { "min-height": "650" } },
                    [
                      _c(
                        "v-row",
                        {
                          staticClass: "pa-4",
                          attrs: { align: "center", "no-gutters": "" }
                        },
                        [
                          _c(
                            "div",
                            {
                              staticClass: "title-header",
                              staticStyle: { "font-size": "14px" }
                            },
                            [_vm._v("Detalles de Contacto")]
                          )
                        ]
                      ),
                      _c("v-divider"),
                      _vm.contact.id === -1 || _vm.loadingContactFailed
                        ? _c(
                            "v-container",
                            { staticClass: "align-center empty-state" },
                            [
                              _c("br"),
                              _c("br"),
                              _c("br"),
                              _c("br"),
                              _c("br"),
                              _c("br"),
                              _c(
                                "v-row",
                                { staticClass: "align-center" },
                                [
                                  _c(
                                    "v-col",
                                    {
                                      staticClass:
                                        "d-flex justify-center pa-0 ma-0",
                                      attrs: { cols: "12" }
                                    },
                                    [
                                      _c("img", {
                                        attrs: {
                                          src: require("@/assets/empty-state-contacts.png"),
                                          alt: ""
                                        }
                                      })
                                    ]
                                  ),
                                  _c(
                                    "v-col",
                                    {
                                      staticClass:
                                        "d-flex justify-center pa-0 ma-0"
                                    },
                                    [
                                      _c("p", [
                                        _vm.loadingContactFailed
                                          ? _c("span", [
                                              _vm._v(
                                                " Carga de contacto fallida. Por favor intente de nuevo "
                                              )
                                            ])
                                          : _c("span", [
                                              _vm._v(
                                                "Selecciona algún contacto del directorio"
                                              )
                                            ])
                                      ])
                                    ]
                                  )
                                ],
                                1
                              )
                            ],
                            1
                          )
                        : _vm.loadingContact
                        ? _c(
                            "v-container",
                            [
                              _c(
                                "v-row",
                                { staticClass: "mt-5 mb-5" },
                                [
                                  _c("v-col", { attrs: { cols: "1" } }),
                                  _c(
                                    "v-col",
                                    { attrs: { cols: "2" } },
                                    [
                                      _c("v-skeleton-loader", {
                                        staticClass: "mt-3 ml-5",
                                        staticStyle: { transform: "scale(2)" },
                                        attrs: { type: "avatar" }
                                      })
                                    ],
                                    1
                                  ),
                                  _c(
                                    "v-col",
                                    { attrs: { cols: "7" } },
                                    [
                                      _c("v-skeleton-loader", {
                                        staticClass: "mt-n3",
                                        staticStyle: {
                                          transform: "scale(1.2)"
                                        },
                                        attrs: { type: "list-item-two-line" }
                                      })
                                    ],
                                    1
                                  )
                                ],
                                1
                              ),
                              _vm._l(3, function(n, index) {
                                return _c(
                                  "span",
                                  { key: index + "-personalInfo" },
                                  [
                                    _c(
                                      "v-row",
                                      { staticClass: "mb-n9" },
                                      [
                                        !_vm.$vuetify.breakpoint.mdAndUp
                                          ? _c("v-col", {
                                              attrs: { cols: "2", lg: "0" }
                                            })
                                          : _vm._e(),
                                        _c(
                                          "v-col",
                                          { attrs: { cols: "4", lg: "3" } },
                                          [
                                            _c("v-skeleton-loader", {
                                              attrs: { type: "list-item" }
                                            })
                                          ],
                                          1
                                        ),
                                        _c(
                                          "v-col",
                                          {
                                            staticClass: "ml-n4",
                                            attrs: { cols: "3", lg: "4" }
                                          },
                                          [
                                            _c("v-skeleton-loader", {
                                              attrs: { type: "list-item" }
                                            })
                                          ],
                                          1
                                        ),
                                        _c("v-col", {
                                          attrs: { cols: "3", lg: "0" }
                                        })
                                      ],
                                      1
                                    ),
                                    n === 3
                                      ? _c(
                                          "v-row",
                                          { staticClass: "mb-n3" },
                                          [
                                            _c("v-col", {
                                              attrs: { cols: "6", lg: "3" }
                                            }),
                                            _c(
                                              "v-col",
                                              { attrs: { cols: "4" } },
                                              [
                                                _c("v-skeleton-loader", {
                                                  attrs: { type: "divider" }
                                                })
                                              ],
                                              1
                                            )
                                          ],
                                          1
                                        )
                                      : _vm._e()
                                  ],
                                  1
                                )
                              }),
                              _vm._l(
                                _vm.isDaycohostUser && !_vm.customerManagement
                                  ? 2
                                  : 3,
                                function(m, index) {
                                  return _c(
                                    "span",
                                    { key: index + "-contactInfo" },
                                    [
                                      _c(
                                        "v-row",
                                        { staticClass: "mb-n9" },
                                        [
                                          _c("v-col", {
                                            attrs: { cols: "3", lg: "1" }
                                          }),
                                          _c(
                                            "v-col",
                                            { attrs: { cols: "3", lg: "2" } },
                                            [
                                              _c("v-skeleton-loader", {
                                                attrs: { type: "list-item" }
                                              })
                                            ],
                                            1
                                          ),
                                          _c(
                                            "v-col",
                                            {
                                              staticClass: "ml-n4",
                                              attrs: { cols: "3", lg: "4" }
                                            },
                                            [
                                              _c("v-skeleton-loader", {
                                                attrs: { type: "list-item" }
                                              })
                                            ],
                                            1
                                          ),
                                          _c("v-col", {
                                            attrs: { cols: "3", lg: "0" }
                                          })
                                        ],
                                        1
                                      ),
                                      m ===
                                      (_vm.isDaycohostUser &&
                                      !_vm.customerManagement
                                        ? 2
                                        : 3)
                                        ? _c(
                                            "v-row",
                                            { staticClass: "mb-n3" },
                                            [
                                              _c("v-col", {
                                                attrs: { cols: "6", lg: "3" }
                                              }),
                                              _c(
                                                "v-col",
                                                { attrs: { cols: "4" } },
                                                [
                                                  _c("v-skeleton-loader", {
                                                    attrs: { type: "divider" }
                                                  })
                                                ],
                                                1
                                              )
                                            ],
                                            1
                                          )
                                        : _vm._e()
                                    ],
                                    1
                                  )
                                }
                              ),
                              _vm._l(2, function(o, index) {
                                return _c(
                                  "span",
                                  { key: index + "-employeeInfo" },
                                  [
                                    _c(
                                      "v-row",
                                      { staticClass: "mb-n9" },
                                      [
                                        _c("v-col", {
                                          attrs: { cols: "3", lg: "1" }
                                        }),
                                        _c(
                                          "v-col",
                                          { attrs: { cols: "3", lg: "2" } },
                                          [
                                            _c("v-skeleton-loader", {
                                              attrs: { type: "list-item" }
                                            })
                                          ],
                                          1
                                        ),
                                        _c(
                                          "v-col",
                                          {
                                            staticClass: "ml-n4",
                                            attrs: { cols: "3", lg: "4" }
                                          },
                                          [
                                            _c("v-skeleton-loader", {
                                              attrs: { type: "list-item" }
                                            })
                                          ],
                                          1
                                        ),
                                        _c("v-col", {
                                          attrs: { cols: "3", lg: "0" }
                                        })
                                      ],
                                      1
                                    )
                                  ],
                                  1
                                )
                              }),
                              _c(
                                "v-row",
                                { staticClass: "mt-2 ml-n6" },
                                [
                                  _c(
                                    "v-col",
                                    { attrs: { cols: "6", lg: "4" } },
                                    [
                                      _c("v-skeleton-loader", {
                                        attrs: { type: "list-item" }
                                      })
                                    ],
                                    1
                                  )
                                ],
                                1
                              ),
                              _c(
                                "v-row",
                                [
                                  _c(
                                    "v-col",
                                    [
                                      _c("v-skeleton-loader", {
                                        staticClass: "mt-n5 mx-1",
                                        attrs: { type: "image" }
                                      })
                                    ],
                                    1
                                  )
                                ],
                                1
                              )
                            ],
                            2
                          )
                        : _c(
                            "v-container",
                            { attrs: { "grid-list-md": "" } },
                            [
                              _c(
                                "v-row",
                                { staticClass: "mb-n12" },
                                [
                                  _c("v-col", { attrs: { cols: "11" } }),
                                  _c(
                                    "v-col",
                                    { attrs: { cols: "1" } },
                                    [
                                      !_vm.isDaycohostUser ||
                                      _vm.customerManagement
                                        ? _c(
                                            "v-menu",
                                            {
                                              attrs: {
                                                "offset-y": "",
                                                "offset-x": "",
                                                left: "",
                                                "offset-overflow": "",
                                                "close-on-content-click": false
                                              },
                                              scopedSlots: _vm._u(
                                                [
                                                  {
                                                    key: "activator",
                                                    fn: function(ref) {
                                                      var on = ref.on
                                                      return [
                                                        _c(
                                                          "v-btn",
                                                          _vm._g(
                                                            {
                                                              attrs: {
                                                                icon: ""
                                                              }
                                                            },
                                                            on
                                                          ),
                                                          [
                                                            _c(
                                                              "v-icon",
                                                              {
                                                                staticStyle: {
                                                                  transform:
                                                                    "scale(1.2)"
                                                                }
                                                              },
                                                              [
                                                                _vm._v(
                                                                  "mdi-dots-vertical"
                                                                )
                                                              ]
                                                            )
                                                          ],
                                                          1
                                                        )
                                                      ]
                                                    }
                                                  }
                                                ],
                                                null,
                                                false,
                                                2262209999
                                              ),
                                              model: {
                                                value: _vm.menu,
                                                callback: function($$v) {
                                                  _vm.menu = $$v
                                                },
                                                expression: "menu"
                                              }
                                            },
                                            [
                                              _c(
                                                "v-list",
                                                _vm._l(_vm.options, function(
                                                  option,
                                                  index
                                                ) {
                                                  return _c(
                                                    "v-list-item",
                                                    {
                                                      key: index,
                                                      on: {
                                                        click: function(
                                                          $event
                                                        ) {
                                                          return _vm.executeOptionFunction(
                                                            option.title
                                                          )
                                                        }
                                                      }
                                                    },
                                                    [
                                                      _c(
                                                        "v-icon",
                                                        {
                                                          staticClass: "ml-3",
                                                          staticStyle: {
                                                            transform:
                                                              "scale(1.2)"
                                                          },
                                                          attrs: { medium: "" }
                                                        },
                                                        [
                                                          _vm._v(
                                                            _vm._s(option.icon)
                                                          )
                                                        ]
                                                      ),
                                                      _c(
                                                        "v-list-item-title",
                                                        { staticClass: "ml-6" },
                                                        [
                                                          _vm._v(
                                                            _vm._s(option.title)
                                                          )
                                                        ]
                                                      )
                                                    ],
                                                    1
                                                  )
                                                }),
                                                1
                                              )
                                            ],
                                            1
                                          )
                                        : _vm._e()
                                    ],
                                    1
                                  )
                                ],
                                1
                              ),
                              _c("contact-detail", {
                                attrs: {
                                  contact: _vm.contact,
                                  "is-customer-management":
                                    _vm.customerManagement,
                                  "is-daycohost-user": _vm.isDaycohostUser
                                }
                              })
                            ],
                            1
                          )
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          ),
      _c(
        "v-dialog",
        {
          attrs: { persistent: "", "max-width": "800" },
          model: {
            value: _vm.deleteDialog,
            callback: function($$v) {
              _vm.deleteDialog = $$v
            },
            expression: "deleteDialog"
          }
        },
        [
          _c(
            "v-container",
            { staticClass: "white py-0 pb-5", attrs: { fluid: "" } },
            [
              _c(
                "v-row",
                [
                  _c(
                    "v-col",
                    {
                      staticClass:
                        "modal-title white--text d-flex justify-space-between align-center"
                    },
                    [
                      _c(
                        "h3",
                        {
                          staticClass: "d-flex align-center font-weight-regular"
                        },
                        [
                          _c("v-icon", { attrs: { dark: "" } }, [
                            _vm._v("mdi-delete")
                          ]),
                          _vm._v("Eliminar contacto ")
                        ],
                        1
                      ),
                      _c(
                        "v-icon",
                        {
                          attrs: { dark: "" },
                          on: {
                            click: function($event) {
                              _vm.deleteDialog = false
                            }
                          }
                        },
                        [_vm._v("mdi-close")]
                      )
                    ],
                    1
                  )
                ],
                1
              ),
              !_vm.deletingContact
                ? _c(
                    "v-row",
                    [
                      _c(
                        "v-col",
                        {
                          staticClass: "d-flex justify-center",
                          attrs: { cols: "12" }
                        },
                        [
                          _c("br"),
                          _c(
                            "h2",
                            {
                              staticClass: "headline",
                              staticStyle: { "text-align": "center" }
                            },
                            [
                              _vm._v(
                                " ¿Estás seguro que deseas eliminar al siguiente contacto de su directorio? "
                              )
                            ]
                          )
                        ]
                      ),
                      _c(
                        "v-col",
                        {
                          staticClass: "d-flex justify-center",
                          attrs: { cols: "12" }
                        },
                        [
                          _c(
                            "v-avatar",
                            { attrs: { color: "pink", size: "115" } },
                            [
                              !!_vm.contact.lastName && !!_vm.contact.name
                                ? _c(
                                    "span",
                                    {
                                      staticClass: "white--text display-2",
                                      staticStyle: { "text-align": "center" }
                                    },
                                    [
                                      _vm._v(
                                        " " +
                                          _vm._s(
                                            _vm.contact.lastName[0].toUpperCase() +
                                              _vm.contact.name[0].toUpperCase()
                                          ) +
                                          " "
                                      )
                                    ]
                                  )
                                : _vm._e()
                            ]
                          )
                        ],
                        1
                      ),
                      _c(
                        "v-col",
                        {
                          staticClass: "d-flex justify-center",
                          attrs: { cols: "12" }
                        },
                        [
                          _c(
                            "h2",
                            { staticStyle: { "text-align": "center" } },
                            [
                              _vm._v(
                                " " +
                                  _vm._s(
                                    _vm.displayContactNames(
                                      _vm.contact.lastName,
                                      _vm.contact.name
                                    )
                                  ) +
                                  " "
                              )
                            ]
                          )
                        ]
                      ),
                      _c(
                        "v-col",
                        {
                          staticClass: "d-flex justify-center",
                          attrs: { cols: "12" }
                        },
                        [
                          _c(
                            "div",
                            {
                              staticClass: "title font-weight-regular",
                              staticStyle: { "text-align": "center" }
                            },
                            [
                              _vm._v(
                                " Si procede no podrá recuperar la información de este contacto "
                              )
                            ]
                          )
                        ]
                      ),
                      _c(
                        "v-col",
                        {
                          staticClass: "d-flex flex-row-reverse",
                          attrs: { cols: "12" }
                        },
                        [
                          _c(
                            "v-btn",
                            {
                              staticClass: "white--text mr-7",
                              attrs: { color: "green", outlined: "" },
                              on: {
                                click: function($event) {
                                  _vm.deleteDialog = false
                                }
                              }
                            },
                            [_vm._v("Cancelar")]
                          ),
                          _c(
                            "v-btn",
                            {
                              staticClass: "white--text mr-7",
                              attrs: { color: "green" },
                              on: { click: _vm.deleteContact }
                            },
                            [_vm._v("Eliminar")]
                          )
                        ],
                        1
                      )
                    ],
                    1
                  )
                : _vm._e()
            ],
            1
          )
        ],
        1
      ),
      _c("activate-user", {
        ref: "activateModal",
        attrs: {
          contactToModify: _vm.contactToModify,
          activationMode: _vm.activationMode
        },
        on: { closeDialog: _vm.activationsDone }
      }),
      _c(
        "v-snackbar",
        {
          attrs: { top: "", timeout: 15000, color: _vm.snackbarColor },
          model: {
            value: _vm.snackbar,
            callback: function($$v) {
              _vm.snackbar = $$v
            },
            expression: "snackbar"
          }
        },
        [
          _vm._v(" " + _vm._s(_vm.snackbarText) + " "),
          _c(
            "v-btn",
            {
              attrs: { color: "white", text: "" },
              on: { click: _vm.closeSnackbar }
            },
            [_vm._v(" Cerrar ")]
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }